<template>
  <div class="recordlist">
    <no-data
      no-text="您还未有任何报告数据~"
      v-show="recordlist.length == 0"
    ></no-data>
    <div
      class="record"
      v-for="item in recordlist"
      :key="item.id"
      @click="toDetails(item)"
    >
      <div class="re_left">
        <img :src="ossUrl + '/blueCircle.png'" />
      </div>
      <div class="re_right">
        <div class="detail_left">
          <img class="right_icon" :src="ossUrl + '/recordicon.png'" />
          <div>
            <div class="re_time">{{ item.created_at }}</div>
            <div class="name">
              <!-- <span :title="item.companys.name">{{
                item.facilitys == null ||
                item.facilitys.name == null ||
                item.facilitys.name == ""
                  ? item.companys.name
                  : item.facilitys.name
              }}</span
              >- -->
              {{ item.report_type }}
            </div>
          </div>
        </div>
        <div class="detail_right">
          <div class="score">{{ item.marks }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Report from "../models/Report";
import NoData from "@/components/NoData";
import { ossUrl } from "@/config";
export default {
  name: "ReportList",
  components: { NoData },
  data() {
    return {
      ossUrl,
      recordlist: [],
    };
  },
  computed: {
    userNo() {
      return this.$route.query.user_no || "";
    },
  },
  created() {
    this.getRecordlists();
  },
  methods: {
    toDetails(item) {
      const url = this.chooseReport(item.report_type);
      this.$router.push(`${url}?id=${item.id}&user_no=${this.userNo}`);
    },
    /** 获取报告路径 */
    chooseReport(type) {
      let url = "";
      switch (type) {
        case "慢性病风险评估":
          url = "/diaeaseReport";
          break;
        case "变异风险评估":
          url = "/riskReport";
          break;
        case "甲状腺评估":
          url = "/thyroid";
          break;
        case "心脑血管评估":
          url = "/HeartBrainReport";
          break;
        case "肠胃动力评估":
          url = "/keynote";
          break;
        case "骨健康评估":
          url = "/GuReport";
          break;
        case "多维健康评估":
          url = "/PeaceMindH5";
          break;
        case "重疾风险评估":
          url = "/riskReport";
          break;
        case "营养评估":
          url = "/nutrition";
          break;
        case "运动风险评估":
          url = "/SportsRiskReport";
          break;
          break;
        case "全景智导健康评估":
          url = "/NewReportFullView";
          break;
        default:
          url = "/NewReport";
      }
      return url;
    },
    getRecordlists() {
      Report.getReportList(
        {
          page: this.page,
          pagesize: this.pageSize,
          user_no: this.userNo,
        },
        (res) => {
          this.recordlist = res.data;
        }
      );
      // let page = this.page;
      // let recordlist = this.recordlist;

      // console.log('data.data',data.data)
      // if(data.data.length!==0){
      // this.setData({
      //     recordlist:recordlist.concat(data.data),
      //     downStatus:false,
      //     total:data.meta.total,
      //     noData:false
      // })
      // }else{
      // this.setData({
      //     noData:true,
      //     downStatus:false
      // })
      // }
      // loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
/* 档案列表 */
.recordlist {
  width: 640px;
  margin: auto;
  padding-top: 56px;
  overflow: auto;
}
.scrollview {
  height: 1200px;
}
.record {
  display: flex;
}
.re_left {
  position: relative;
  width: 48px;
  height: 48px;
}
.re_left img {
  width: 48px;
  height: 48px;
}
.record:first-child .re_left::before {
  content: "";
  position: absolute;
  top: -40px;
  left: 0;
  right: 0;
  width: 6px;
  height: 56px;
  background-color: #e0e5e9;
  margin: auto;
}
.re_left:after {
  content: "";
  position: absolute;
  top: 58px;
  left: 0;
  right: 0;
  width: 6px;
  height: 132px;
  background-color: #e0e5e9;
  margin: auto;
}
.record:last-child .re_left::after {
  height: 256px;
}
.re_right {
  position: relative;
  width: 584px;
  height: 144px;
  border: 1px solid #e5e5e5;
  margin-left: 24px;
  /* background: -webkit-linear-gradient(left,#9FE4FF 10%, #2E94E5 90% );
  background: -o-linear-gradient(left,#9FE4FF 10%, #2E94E5 90%);
  background: -moz-linear-gradient(left,#9FE4FF 10%, #2E94E5 90% );
  background: -mos-linear-gradient(left,#9FE4FF 10%, #2E94E5 90% );
  background: linear-gradient(left,#9FE4FF 10%, #2E94E5 90%); */
  background-color: #2e94e5;
  margin-bottom: 32px;
  border-radius: 5px;
  /* box-shadow: 0 0 8px 1px rgba(7, 0, 2, 0.2); */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  color: #fff;
}
.re_right::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 12px;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-right: 10px solid #2e94e5;
  border-bottom: 5px solid transparent;
}
.re_right .detail_left {
  flex: 1;
  display: flex;
  justify-content: start;
}
.re_right .detail_left .right_icon {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  margin-right: 23px;
}
.re_right .detail_left .re_time {
  color: #d8fffd;
  font-size: 26px;
  margin-bottom: 5px;
  width: 300px;
}
.re_right .detail_left .name {
  font-size: 22px;
  width: 300px;
  height: 40px;
  line-height: 40px;
  display: flex;
}
.re_right .detail_left .name text {
  font-size: 26px;
  margin-right: 20px;
  width: 145px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.re_right .detail_right {
  position: relative;
  width: 95px;
  height: 95px;
  border-radius: 50%;
  border: 3px solid #fff;
  border-radius: 50% 50% 50% 50%;
  font-size: 40px;
  text-align: center;
  line-height: 98px;
}
.re_right .detail_right::after {
  content: "";
  position: absolute;
  top: -12px;
  right: -17px;
  width: 55px;
  height: 55px;
  background-color: #2e94e5;
}
.re_right .detail_right .score {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}
</style>